export default {
    name: 'production',
    baseURL: 'https://api.vinaid.vn:1443',
    reportURL: 'https://api.vinaid.vn:1450',
    kiotUrl: 'https://api.vinaid.vn:1446',
    wsURL: 'https://api.vinaid.vn:1445/socket',
    s3url: 'https://s3.vinaid.vn',
    captchaSiteKey: '6LfjN_wpAAAAALFlgQCfWWzB62pn1x1tE6GFXs8d',
    keycloakUrl: 'https://auth.truonghocsoquocgia.vn',
    keycloakRealm: 'truong-hoc-so-quoc-gia',
    keycloakClientId: 'lms',
    keycloakRedirectUri: 'https://thpt-mydinh.id.truonghocsoquocgia.vn',
    partnerId: 'cd6a5c9f-7847-43b8-96a5-3a0f5a393ea1',
}
